import { useMediaQuery } from '@mui/material'
import { PureLightTheme } from '../../../styles/theme'
import { SocialOrderInfoProps } from '../../../types/entitys/socialOrders'
import { SocialOrderInfoDesktop } from './Desktop'
import { SocialOrderInfoMobile } from './Mobile'

export const SocialOrderInfo = ({ socialOrder }: SocialOrderInfoProps) => {
  const isMobile = useMediaQuery(PureLightTheme.breakpoints.down("md"));
  
  return isMobile ? <SocialOrderInfoMobile socialOrder={socialOrder} /> : <SocialOrderInfoDesktop socialOrder={socialOrder} />;
}
